import {
  IDelayTimerConstraints,
  IEmailIRoute,
  IFixedDateStrategy,
  ILearnisticApp,
  IManageTag,
  IStopTag,
  ITagConditions,
} from "../generated/Api";
import { INamedTagQuery } from "./TagQueryTypes";

export interface IEmailAction {
  subject: string;
  body: string;
}
export interface ISms {
  message: string;
}

export interface IPushNotification {
  title: string;
  content: string;
  link?: string;
}

export interface IWebHook {
  url: string;
  contentType: "form-data" | "json";
  authorization?: string;
  fields: { name: string; value: string }[];
}
export interface ISetField {
  field: string;
  newValue: string;
}
export interface IApplyNote {
  title: string;
  description?: string;
  timestamp: Date;
}

export interface IEmailAction {
  subject: string;
  body: string;
  footerId: string;
  aliasId: string;
  interestingURLs?: IEmailIRoute["interestingURLs"];
}

export type IActionTypes = INodeTypes.Email;

export interface IDelayTimer {
  delay: number;
  unit: number;
  constraints?: IDelayTimerConstraints;
}

export interface IDateTimer {
  date: Date;
}

export interface IFilter {
  tagQuery: INamedTagQuery;
}

export enum INodeTypes {
  Email = "email",
  DelayTimer = "delayTimer",
  DateTimer = "dateTimer",
  ManageTag = "manageTag",
  StopTag = "stopTag",
  Sms = "sms",
  Filter = "filter",
  PushNotification = "pushNotification",
  WebHook = "webHook",
  SetField = "setField",
  ApplyNote = "applyNote",
}

export enum ICampaignStatus {
  Active = "Active",
  Inactive = "Inactive",
  Draft = "Draft",
  Archive = "Archive",
}

export type INode = {
  _id?: string;
  name: string;
  type: INodeTypes;
  [INodeTypes.Email]?: IEmailAction;
  [INodeTypes.ManageTag]?: IManageTag;
  [INodeTypes.StopTag]?: IStopTag;
  [INodeTypes.DelayTimer]?: IDelayTimer;
  [INodeTypes.DateTimer]?: IDateTimer;
  [INodeTypes.Sms]?: ISms;
  [INodeTypes.PushNotification]?: IPushNotification;
  [INodeTypes.WebHook]?: IWebHook;
  [INodeTypes.SetField]?: ISetField;
  [INodeTypes.ApplyNote]?: IApplyNote;
  [INodeTypes.Filter]?: IFilter;
};

export interface Campaign {
  _id: string;
  name: string;
  nodes: Array<INode>;
  status: ICampaignStatus;
  totalContacts: number;
  activeContacts: number;
  tagConditions: Array<ITagConditions>;
  stopTagConditions?: (string | ILearnisticApp)[];
  createdAt: Date;
  labels: string[];
  launchedAt?: Date;
  notes: string;
  lastNotesUpdate: Date;
  campaignOptions: {
    defaultFooterId: string;
    defaultAliasId: string;
    fixedDateStrategy: IFixedDateStrategy;
    fixed?: boolean;
    preventReentering?: boolean;
    overrideFooters?: boolean;
  };
}

export interface CampaignFilters {
  limit?: number;
  offset?: number;
  orderByOrientation: -1 | 1;

  /**
   * These are real strings
   */
  orderBy: "createdAt" | "activeContacts" | "name";
  labels?: string[] | string;
  status?: string[] | string;
  name?: string;
}
